import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-modal", async () => {
    it("passes the regression test", async () => {
        expect(true).toBe(true);
        await regressionTest({
            storyId: getTestStory("modal", "modal"),
            componentTag: "ux-modal",
            allowNotVisible: true,
            performActions: async (page) => {
                await page.click(
                    "button[data-trigger-modal='open,basic-modal']"
                );
                await page.waitForSelector(".ux-modal--opened");
            },
        });
    });
});
